import { Component, Input, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'at-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {

  @Input() content: string;
  @Input() square: boolean;
  @Input() rounded: boolean;
  @Input() link: boolean;
  @Input() remove: boolean;
  @Input() color: string;

  constructor(private element: ElementRef) { }

  ngOnInit() {
  }

  closeTag() {
    this.element.nativeElement.getElementsByClassName('at-tag')[0].classList.add('hidden');
  }

}
